import React, { useMemo, useState, useCallback } from 'react';
import { useHistory } from 'react-router';
import AppContext from '../../context/AppContext';
import useTitle from '../../util/useTitle';
import InternalLayout from '../layouts/InternalLayout';
import WORKPAGE_COMPONENTS from './fields';

function Workpage({ schema, scope }) {
  const { title, elements } = schema || {};

  useTitle(title);
  const history = useHistory();
  const grid_size = 4;

  const [workpageData, _setWorkpageData] = useState({});
  const setWorkpageData = useCallback(
    (name, value) => {
      _setWorkpageData(dd => ({ ...dd, [name]: value }));
    },
    [_setWorkpageData]
  );

  if (typeof scope !== 'undefined') {
    scope.setworkpageData = setWorkpageData;
    scope.workpageData = workpageData;
  }

  return elements?.length ? (
    <div className="workpage">
      {
        elements.reduce(
          (_, element, idx) => {
            let { col = _.lastColEnd, colSpan = grid_size } = element;
            colSpan = Math.min(colSpan, grid_size);
            let colEnd = col + colSpan;

            if (colEnd > grid_size + 1) {
              col = 1;
              colEnd = col + colSpan;
            }

            _.lastColEnd = ((colEnd - 1) % grid_size) + 1;

            const Component = WORKPAGE_COMPONENTS[element.type];

            _.list.push(
              <div key={idx} className={`workpage-widget from-col-${col} to-col-${colEnd}`}>
                {Component ? <Component element={element} history={history} scope={scope} /> : null}
              </div>
            );

            return _;
          },
          { lastColEnd: 1, list: [] }
        ).list
      }
    </div>
  ) : null;
}

const WRAPPERS = {
  internal: (workpage, workpageDef) => (
    <InternalLayout>
      {workpageDef.tab ? <AppContext.SetSidebarTab value={workpageDef.tab} /> : null}
      {workpage}
    </InternalLayout>
  ),
};

Workpage.HOC = function(workpageDef) {
  const { name = 'Workpage', wrapperType, wrapper, schema } = workpageDef;
  const schemaFn = typeof schema === 'function' ? schema : () => schema;
  const wrapperFn = wrapper || WRAPPERS[wrapperType] || (children => children);

  const scope = {
    workpage: workpageDef,
  };

  function HOC() {
    const schema = useMemo(schemaFn, [schemaFn]);

    return wrapperFn(<Workpage schema={schema} scope={scope} />, workpageDef);
  }

  HOC.DisplayName = name || 'WorkpageHOC';

  return HOC;
};

export default Workpage;
